/* eslint-disable @typescript-eslint/member-ordering */
import { HttpErrorResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Optional, Output, ViewChild, ChangeDetectorRef, OnDestroy, HostListener } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { UserService } from 'app/pages/com.usblick.common/auth/user.service';
import { RestService } from 'app/shared/rest.service';
import * as moment from "moment";
import { of, Subject } from 'rxjs';
import { debounceTime, filter, switchMap, takeUntil } from 'rxjs/operators';
import { AddressesService } from '../../service/addresses.service';
import { BsModalRef, BsModalService, ModalOptions } from 'ngx-bootstrap/modal';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { setting } from '../../../../../../setting';
import { NotFoundModalComponent } from 'app/shared/modals/not-found-modal/not-found-modal.component';
import { ItineraryService } from 'app/shared/itinerary.service';
import { NotificationService } from 'app/shared/notifications/notification.service';

@Component({
  selector: 'usb-flights',
  templateUrl: './flights.component.html',
  styleUrls: ['./flights.component.scss'],
  providers: [AddressesService]
})
export class FlightsComponent implements OnInit, OnDestroy {

    @Input() _close: boolean;
    @Input() getClientsSettingAppBooking: any;

    @Output() payload = new EventEmitter<any>();
    @Output() results = new EventEmitter<any>();
    @Output() isLoading = new EventEmitter<boolean>();
    @Output() origin = new EventEmitter<any>();
    @Output() modal = new EventEmitter<string>();

    @ViewChild('triggerButton') triggerButton: ElementRef;
    @ViewChild('cardSelectorRoom') cardSelectorRoom: ElementRef;
    @ViewChild('datePicker', { read: ElementRef }) datePickerInput: ElementRef;
    @ViewChild('datePicker_', { read: ElementRef }) datePickerInput2: ElementRef;

    _form!: FormGroup;
    loadingData: boolean = false;
    validateButtonSearch: boolean = false;
    itineraryActive: any[] = [];
    componentResults: boolean = false;
    _findData: boolean;
    _resultsQuery: any;
    routerStorage: any;
    config = {
      animated: true,
      keyboard: false,
      backdrop: true,
      ignoreBackdropClick: true
    };

    countryPickupLocation: string;
    countryDropoffLocation: string;

    isHovered: boolean = false;

    // minDate: dayjs.Dayjs = dayjs().subtract(0, 'days');
    // maxDate: dayjs.Dayjs = dayjs().add(12, 'month');
    isCollapsed = false;
    dpConfig: Partial<BsDatepickerConfig> = new BsDatepickerConfig();
    now = new Date();
    minDate: Date;

    _maxPersons: any;
    passengers: string;
    private closing = false;

    showModal: boolean = false;
    titleModal: string = 'Advertencia';
    messageModal: string = 'Cree un file en la barra superior para poder iniciar una búsqueda';
    selectedWay: string = 'way';

    selectedNoDateDefined: boolean = false;

    bsModalRef?: BsModalRef;
    bgClientColor: string = 'black';
    bookingFlowSidebar: any;
    backgroundDisplayContrast: any;


    originOptionsLegs: any[] = [];
    destinationOptionsLegs: any[] = [];
    private activeLocationInput: {
      element: EventTarget | null;
      trigger: MatAutocompleteTrigger;
      type: 'origin' | 'destination';
      legIndex: number;
    } | null = null;


    wayArr: any[] = [
      {value: 'way', label: 'Ida'},
      {value: 'twoWay', label: 'Ida y vuelta'},
      {value: 'multi', label: 'Multidestino'}
    ]

    cabinClassArr: any[] = [
      {value: 'Economy', label: 'Económica'},
      {value: 'Premium Economy', label: 'Premium Economy'},
      {value: 'Business', label: 'Business'},
      {value: 'First', label: 'Primera Clase'}
    ]

    // Tracks where the user pressed the mouse down, para distinguir un click
    // que terminó dentro de un campo de texto de un click-outside real.
    private mouseDownTarget: EventTarget | null = null;

    @HostListener('document:mousedown', ['$event'])
    onDocumentMouseDown(event: MouseEvent) {
      this.mouseDownTarget = event.target;
    }

    @HostListener('document:click', ['$event'])
    onClickOutside(event: MouseEvent) {
      if (!this.isCollapsed || this.closing) {
        return;
      }

      const downOnTextField =
        this.mouseDownTarget instanceof HTMLInputElement ||
        this.mouseDownTarget instanceof HTMLTextAreaElement ||
        this.mouseDownTarget instanceof HTMLSelectElement;
      this.mouseDownTarget = null;
      if (downOnTextField) {
        return;
      }

      const clickedTrigger = this.triggerButton?.nativeElement.contains(event.target);
      const clickedSelector = this.cardSelectorRoom?.nativeElement.contains(event.target);

      if (!clickedTrigger && !clickedSelector) {
        this.closing = true;
        this._confirm();
      }
    }

  private _unsubscribeAll: Subject<any> = new Subject<any>();

  constructor(
              private formBuilder: FormBuilder,
              public userService: UserService,
              private _restService: RestService,
              private _router: Router,
              private notificationService: NotificationService,
              private _addressService: AddressesService,
              private modalService: BsModalService,
              private cdr: ChangeDetectorRef,
              private _itineraryService: ItineraryService,
              @Inject(MAT_DIALOG_DATA) public data: any,
              @Optional() public dialogRef: MatDialogRef<FlightsComponent>
  ) { }

  ngOnInit(): void {
                    const now = new Date();
                this.now = new Date(now.getFullYear(), now.getMonth(), now.getDate());
                this.dpConfig = { dateInputFormat: 'DD/MM/YYYY'  };
                this.minDate = new Date();
                this.minDate.setDate(this.minDate.getDate() + 1);
                this._maxPersons = Array.from(Array(100).keys());
                this.passengers = 'Pasajeros';
                this.routerStorage = setting.apiStorageBooking;
                this.componentResults = this.data && this.data?.component === 'results' ? true : false;
                     if(this.componentResults) {
                          this.loadingData = true;
                     }
                this.itineraryActive = this.userService.itineraryActive;
                this.clientData();
                this.initForm();

                this._itineraryService.itinerary$.pipe(takeUntil(this._unsubscribeAll)).subscribe(() => {
                  this.cdr.detectChanges();
                });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

    clientData(): void {
    if(this.data && this.data?.clientSetting) {
                  this.getClientsSettingAppBooking = this.data?.clientSetting;
                }
    this.bgClientColor = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_1;
    this.bookingFlowSidebar = JSON.parse(this.getClientsSettingAppBooking.clients_setting_app_booking?.bookingFlow_sidebar);
    this.backgroundDisplayContrast = this.bookingFlowSidebar?.background_color;
  }

  initForm(): void {
    // Formulario principal
    this._form = this.formBuilder.group({
      cabinClass: new FormControl(''),
      airlines: new FormControl([]),
      returnDate: new FormControl(null),
      legs: this.formBuilder.array([]),  // FormArray para los legs
      passengers: this.formBuilder.group({
        adults: [1, [Validators.required, Validators.min(1)]],
        qtyChilds: [0],
        childsage: this.formBuilder.array([]),
        infants: [0]
      })
    });

    this.setPassanger();

    // Agregar primer leg por defecto
    this.addLeg();

    // La fecha de regreso no puede quedar antes de la fecha de ida:
    // si la fecha de ida cambia y la de regreso ya cargada queda inválida, se limpia.
    this.legsFormArray.at(0)?.get('date')?.valueChanges.subscribe((departureDate) => {
      const returnDateControl = this._form.get('returnDate');
      const returnDateValue = returnDateControl?.value;
      if (departureDate && returnDateValue && new Date(returnDateValue) < new Date(departureDate)) {
        returnDateControl.setValue(null);
      }
    });
  }

  get passengersGroup(): FormGroup {
    return this._form.get('passengers') as FormGroup;
  }

  /**
   * Fecha mínima seleccionable para el regreso: la fecha de ida ya cargada,
   * o la fecha mínima general si todavía no se cargó ninguna.
   */
  get minReturnDate(): Date {
    const departureDate = this.legsFormArray?.at(0)?.get('date')?.value;
    return departureDate ? new Date(departureDate) : this.now;
  }

  get legsFormArray(): FormArray {
    return this._form.get('legs') as FormArray;
  }


// Agregar un nuevo leg
addLeg(): void {
  const legsArray = this._form.get('legs') as FormArray;

  const legGroup = this.formBuilder.group({
    origin: ['', Validators.required],
    originData: [null],
    destination: ['', Validators.required],
    destinationData: [null],
    date: [null, Validators.required]
  });

  legsArray.push(legGroup);

  // Configurar suscripciones para este nuevo leg
  this.setupLegAutocomplete(legGroup, legsArray.length - 1);
}

// Eliminar un leg
removeLeg(index: number): void {
  const legsArray = this._form.get('legs') as FormArray;
  if (legsArray.length > 1) {  // Mínimo 1 leg
    legsArray.removeAt(index);
    this.originOptionsLegs.splice(index, 1);
    this.destinationOptionsLegs.splice(index, 1);
  }
}

// Configurar autocompletado para un leg específico
private setupLegAutocomplete(legGroup: FormGroup, index: number): void {
  // Origen
  legGroup.get('origin')?.valueChanges.pipe(
    filter(value => !!value && typeof value === 'string'),
    debounceTime(300),
    switchMap(searchValue => this.loadLocations$(searchValue, 'origin')),
    takeUntil(this._unsubscribeAll)
  ).subscribe(options => {
    this.originOptionsLegs[index] = options;
    this.openPanelForActiveInput('origin', index);
  });

  // Destino
  legGroup.get('destination')?.valueChanges.pipe(
    filter(value => !!value && typeof value === 'string'),
    debounceTime(300),
    switchMap(searchValue => this.loadLocations$(searchValue, 'destination')),
    takeUntil(this._unsubscribeAll)
  ).subscribe(options => {
    this.destinationOptionsLegs[index] = options;
    this.openPanelForActiveInput('destination', index);
  });
}

// Guarda el input donde el usuario está tipeando (y su trigger de autocomplete)
// para poder reabrirle el panel cuando llegan los resultados, ver openPanelForActiveInput().
onLocationInput(event: Event, trigger: MatAutocompleteTrigger, type: 'origin' | 'destination', legIndex: number): void {
  this.activeLocationInput = { element: event.target, trigger, type, legIndex };
}

// Los resultados llegan de forma asíncrona (debounce + HTTP). Si en ese momento
// el panel quedó cerrado, hasta ahora el usuario tenía que hacer click de nuevo
// en el input para verlos. Acá se renderizan las opciones y se abre el panel,
// pero solo si el usuario sigue en ese mismo input.
private openPanelForActiveInput(type: 'origin' | 'destination', legIndex: number): void {
  const active = this.activeLocationInput;
  if (!active || active.type !== type || active.legIndex !== legIndex || document.activeElement !== active.element) {
    return;
  }
  this.cdr.detectChanges();
  if (!active.trigger.panelOpen) {
    active.trigger.openPanel();
  }
}

// Busca ubicaciones para un leg específico. Devuelve el array YA RESUELTO
// (no el Observable) para que el template lo lea directo, sin "| async".
//
// Antes se guardaba acá mismo un Observable nuevo en cada tipeo
// (originOptionsLegs[legIndex] = options$) y el template lo consumía con
// "| async". Eso hacía que, en cada tipeo, el async pipe se desuscribiera
// del Observable anterior y quedara en null hasta que el nuevo emitiera —
// en ese hueco el *ngIf pasaba a false, el panel de mat-autocomplete se
// quedaba sin opciones un instante y Angular Material lo cerraba solo (no
// se reabre automáticamente cuando llegan datos nuevos, sólo con un nuevo
// focus). Por eso hacía falta un click afuera + un click de vuelta para
// que el panel volviera a abrirse y recién ahí se viera algo.
//
// switchMap además cancela la búsqueda anterior si el usuario sigue
// tipeando antes de que responda, evitando que una respuesta vieja
// pise a una más nueva.
private loadLocations$(searchValue: string, type: 'origin' | 'destination') {
  if (!searchValue || searchValue.length < 2) {
    return of([]);
  }

  return this._addressService.getLocationsAll(
    searchValue,
    type === 'origin' ? this.countryPickupLocation : this.countryDropoffLocation,
    false,
    'FLIGHTS'
  );
}

// Seleccionar ubicación
selectLocation(option: any, type: 'origin' | 'destination', legIndex: number): void {
  const legsArray = this._form.get('legs') as FormArray;
  const legGroup = legsArray.at(legIndex) as FormGroup;

  const locationData = option.data;

  legGroup.patchValue({
    [type]: locationData,
    [`${type}Data`]: locationData
  });
}

/**
 * Intercambia el origen y destino de un tramo puntual.
 *
 * @legIndex -> índice del tramo (dentro del FormArray `legs`) a invertir.
 */
swapLocations(legIndex: number): void {
  const legsArray = this._form.get('legs') as FormArray;
  const legGroup = legsArray.at(legIndex) as FormGroup;
  if (!legGroup) {
    return;
  }

  const origin = legGroup.get('origin')?.value;
  const destination = legGroup.get('destination')?.value;
  const originData = legGroup.get('originData')?.value;
  const destinationData = legGroup.get('destinationData')?.value;

  legGroup.patchValue({
    origin: destination,
    originData: destinationData,
    destination: origin,
    destinationData: originData
  });
}

/**
 * Extrae el código IATA de una ubicación seleccionada, admitiendo tanto el objeto
 * completo devuelto por el autocompletado como un código ya resuelto.
 */
private getIataCode(location: any): string {
  if (!location) {
    return '';
  }
  if (typeof location === 'string') {
    return location;
  }
  return location.iata || location.code || '';
}

  formPatchValue(): void {
      if(this.data && this.data?.category) {

      if(!this.data.payload) {
        this.loadingData = false;
        return;
      }

      if(this.data.category !== this.data.payload[0].categoriesId[0]) {
        this.loadingData = false;
        return;
      }

      const payload = this.data.payload[0];


      if(!payload) {
        this.loadingData = false;
        return;
      }

      this.loadingData = false;
    }
  }

  /***********************************************Auto Complete********************************************/

  /**
 * Capitaliza una cadena de texto
 *
 * Convierte la cadena a minúsculas, la divide por espacios y pone en mayúscula
 * la primera letra de cada palabra.
 *
 * @val -> string a capitalizar
 * @return -> string con cada palabra capitalizada
 */

capitalize(val: any): string {
  if (!val && val !== 0) return ''; // Manejar null, undefined, empty string, pero mantener 0

  return String(val)
    .toLowerCase()
    .trim()
    .split(/\s+/) // Divide por uno o más espacios
    .filter(word => word.length > 0) // Filtra palabras vacías
    .map(word => {
      // Encontrar el primer carácter alfabético
      const firstLetterMatch = word.match(/[a-zñáéíóúü]/i);

      if (firstLetterMatch) {
        const firstLetterIndex = firstLetterMatch.index || 0;
        // Capitalizar la primera letra alfabética encontrada
        return word.substring(0, firstLetterIndex) +
               word[firstLetterIndex].toUpperCase() +
               word.substring(firstLetterIndex + 1);
      }

      // Si no hay letras, devolver la palabra tal cual
      return word;
    })
    .join(' ');
}

  /**
 * Método para mostrar el nombre de una ubicación.
 *
 * Este método construye y devuelve una cadena con el nombre del hotel, la dirección, el código IATA, el código de destino
 * o el código de país de la ubicación. La información es extraída del objeto `name`.
 *
 * @name -> objeto que contiene la información de la ubicación, como `hotel_name`, `address`, `iata`, `destination_code`, `country_code`.
 * @returns -> una cadena con el nombre y la información adicional de la ubicación.
 */
displayFn(name): string {
  if(name) {
    return `${name.hotel_name ? name.hotel_name : name.name} ${name.address ? "("+name.address+")": ''}${name.iata ? "("+name.iata+")": ''}${name.destination_code ? "("+name.destination_code+")": ''}${name.country_code ? "("+name.country_code+")": ''}`;
  } else {
    return '';
  }
}


  _onSubmit(form, event): void {

    const payload = this.buildPayload();

    if(!payload) {
      return;
    }

    localStorage.setItem("form", JSON.stringify(form.value));

      if (localStorage.getItem("payload")) {
        localStorage.removeItem("payload");
      }

      localStorage.setItem("payload", JSON.stringify([payload]));

       if(this.componentResults) {
        this.dialogRef.close(payload);
        localStorage.setItem('origin', 'FLIGHTS');
    } else {

      this._emitLoading(true);
      this._restService.doPost("app", "search", payload).subscribe({
        next: (response: any) => {
          const flights = response?.results?.[0]?.flights;
          if(response !== null && Array.isArray(flights) && flights.length > 0) {

            const payloadArray = [payload]
            this.payload.emit(payloadArray);
            this._handleResponse(response, "FLIGHTS", form);
            this._emitOrigin("FLIGHTS");
            this._emitLoading(false);
            this._router.navigate(["/results"]);

          } else {
                this._emitLoading(false);
                const initialState: ModalOptions = {
                  initialState: {
                    message: '',
                    confirmText: 'Cerrar',
                    cancelText: 'Volver a intentar',
                    showCancelButton: true,
                    size: 'sm',
                  }
                };
                const modalOptions = Object.assign({}, initialState, this.config);
                this.bsModalRef = this.modalService.show(NotFoundModalComponent, modalOptions);
                  }
                const confirmSubscription = this.bsModalRef?.content?.confirmResult.subscribe((result: boolean) => {
                  if(result) {
                      if (result) {
                        this._onSubmit(form, event);
                          } else {
                            this.bsModalRef.hide();
                            this._router.navigate(["/home"]);
                          }
                        } else {

                        }
                      });
        },
        error: (error: HttpErrorResponse) => {

        }
      });
    }
  }

  /**
   * Construye el payload de búsqueda de vuelos a partir del FormArray `legs`.
   *
   * - 'way': un único tramo, tal cual fue cargado.
   * - 'twoWay': el tramo cargado más uno adicional invertido (destino->origen),
   *   usando `returnDate` como fecha. El usuario no completa un segundo tramo.
   * - 'multi': todos los tramos cargados en el FormArray, cada uno independiente.
   */
  buildPayload(): any {
    const legsArray = this.legsFormArray;
    if (!legsArray || legsArray.length === 0) {
      return null;
    }

    let legs: { origin: string, destination: string, date: string | null }[] = [];

    if (this.selectedWay === 'multi') {
      legs = legsArray.controls.map(legGroup => this.buildLegPayload(legGroup as FormGroup));
    } else {
      const outbound = this.buildLegPayload(legsArray.at(0) as FormGroup);
      legs.push(outbound);

      if (this.selectedWay === 'twoWay') {
        legs.push({
          origin: outbound.destination,
          destination: outbound.origin,
          date: this.formatDateToISO(this._form.get('returnDate')?.value)
        });
      }
    }

    const incompleteLeg = legs.find(leg =>
      !leg.origin || !leg.destination || (!leg.date && !this.selectedNoDateDefined)
    );

    if (incompleteLeg) {
      this.notificationService.info('Completá origen, destino y fecha para cada tramo');
      return null;
    }

    const passengers = this._form.get('passengers')?.value;
    const childrenAges = (passengers?.childsage || []).map((child: any) => child.age);

    return {
      categoriesId: [5],
      others: {
        tours: {
          adults: passengers?.adults || 1,
          children: childrenAges
        }
      },
      legs,
      market: 1,
      currency: 'USD',
      cabinClass: this._form.get('cabinClass')?.value || null,
      airlines: this._form.get('airlines')?.value || [],
      client_id: this.userService.clientIdFusion
    };
  }

  private buildLegPayload(legGroup: FormGroup): { origin: string, destination: string, date: string | null } {
    return {
      origin: this.getIataCode(legGroup.get('origin')?.value),
      destination: this.getIataCode(legGroup.get('destination')?.value),
      date: this.formatDateToISO(legGroup.get('date')?.value)
    };
  }

  private formatDateToISO(date: any): string | null {
  if (!date) return null;

  // Si es un objeto con start/end (rango)
  if (date.start) {
    return moment(date.start).format('YYYY-MM-DD');
  }

  // Si es fecha directa
  return moment(date).format('YYYY-MM-DD');
}


    /**
 * Emite el estado de loading y actualiza el estado interno de búsqueda
 *
 * Este método comunica el estado de carga al componente padre y actualiza
 * la variable interna que controla la visualización del estado de búsqueda.
 *
 * @param {boolean} isLoading - Estado de carga: true si está cargando, false si completó
 * @returns {void}
 *
 * @emits
 * - isLoading: Evento boolean que indica el estado de carga
 *
 * @sideEffects
 * - Actualiza this._findData con el estado de loading
 * - Permite sincronizar el estado interno con la emisión al padre
 *
 * @usage
 * Utilizado durante las operaciones de búsqueda para mostrar/ocultar spinners
 * y prevenir interacciones duplicadas durante la carga
 */
  _emitLoading(isLoading: boolean) {
    this._findData = isLoading;
    this.isLoading.emit(isLoading);
  }

      /**
     * Procesa y normaliza la respuesta de búsqueda para su uso en la aplicación
     *
     * Este método centraliza el manejo de la respuesta del API, agregando metadatos,
     * manejando casos edge de no resultados, y emitiendo los resultados normalizados.
     *
     * @param {any} response - Respuesta cruda del servicio de búsqueda
     * @param {string} categoryName - Nombre de la categoría de búsqueda
     * @param {FormGroup} form - Formulario asociado a la búsqueda
     * @returns {void}
     *
     * @processing
     * 1. ✅ Verifica que response y response.results no sean null
     * 2. ✅ Agrega metadatos: categoryName, arrivalDate, destination
     * 3. ✅ Maneja caso de array vacío con mensaje descriptivo
     * 4. ✅ Adjunta el formulario completo a los resultados
     * 5. ✅ Emite resultados normalizados mediante EventEmitter
     *
     * @errorHandling
     * - Try-Catch: Maneja excepciones inesperadas durante el procesamiento
     * - Fallback: Restablece page a 1 en caso de error
     *
     * @emits
     * - results: Array de resultados procesados y normalizados
     */
      _handleResponse(response: any, categoryName: string, form: FormGroup) {
        if (response && response.results != null) {
          try {
            const legsValue = this.legsFormArray?.value || [];
            const resultsData = categoryName === 'FLIGHTS'
              ? (response.results?.[0]?.flights || [])
              : response.results;

            this._resultsQuery = resultsData;
            delete this._resultsQuery?.dateEnd;
            delete this._resultsQuery?.dateIni;
            this._resultsQuery.categoryName = categoryName;
            this._resultsQuery.searchId = response.searchId;
            this._resultsQuery.arrivalDate = this.formatDateToISO(legsValue[0]?.date);
            this._resultsQuery.destination = this.getIataCode(legsValue[legsValue.length - 1]?.destination);

            if (!resultsData.length) {
              this._resultsQuery.noResultMessage = "No results found for the search";
            }
            // se anexa el formulario actual
            this._resultsQuery.form = form;
            const arrayResults = [this._resultsQuery];
            this.results.emit(arrayResults);
          } catch (e) {
            this._resultsQuery = [];
            this._restService.page = 1;
          }
        } else {
          this._resultsQuery = [];
          this._resultsQuery.noResultMessage = "No results found for the search";
          this.results.emit(this._resultsQuery);
        }
      }

        /**
       * Emite el origen de la búsqueda a través de un EventEmitter
       *
       * Este método permite comunicar el tipo de origen (categoría) de la búsqueda
       * al componente padre mediante un evento emitido.
       *
       * @param {any} origin - Origen/categoría de la búsqueda (ej: "HOTELS", "FLIGHTS")
       * @returns {void}
       *
       * @emits
       * - origin: Evento que contiene el tipo de origen de la búsqueda
       *
       * @usage
       * Utilizado para informar al componente padre sobre el contexto de la búsqueda
       * realizada, permitiendo diferentes comportamientos basados en la categoría
       */
        _emitOrigin(origin: any) {
          this.origin.emit(origin);
        }

              close(): void {

          this.dialogRef.close(null);
        }

          /**
        * Método para obtener la imagen del logotipo de la agencia.
        *
        * Este método obtiene la imagen del logotipo de la agencia desde el servicio `userService`.
        * Si la imagen no está disponible o es igual a la ruta del archivo de la API,
        * retorna una imagen por defecto.
        *
        * @returns-> Ruta de la imagen del logotipo de la agencia o imagen por defecto si no está disponible.
        */
        get agencyImagen(): string {
          let agencyImagen = this.userService._imagen_logotype;
          if (agencyImagen === this.routerStorage || agencyImagen === '') {
              return agencyImagen =  'assets/img/sin-logo.png';
          } else {
              return agencyImagen;
          }
        }

            /**
       * Método para abrir el modal.
       *
       * Este método cambia el estado de la variable `isCollapsed` a `true`, y la variable `_close` a `false`.
       * Después de un pequeño retardo, emite un evento con el valor 'true' para abrir el modal.
       */
      _openModal() {
        // this.applyImageFilter();
        this.isCollapsed = true;
        this._close = false;
        this.closing = false;
        setTimeout(() => {
          this.modal.emit('true');
        }, 100);
      }
/**
 * Abre el modal principal
 *
 * Este método establece la propiedad `showModal` en `true`
 * para mostrar el modal asociado.
 *
 * @showModal -> estado booleano que determina si el modal está activo
 */
fileActive() {
  this.showModal = true;
}

/**
 * Cierra el modal principal
 *
 * Este método cambia la propiedad `showModal` a `false`
 * para cerrar el modal que fue previamente abierto.
 *
 * @showModal -> se establece en falso para cerrar el modal
 */
closeModal() {
  this.showModal = false;
}

    filePaid():void{
    if(this.validateButtonSearch){
      this.titleModal = 'File Completado',
      this.messageModal = 'Este file se encuentra completado, por favor, crea un nuevo file para hacer una búsqueda'
      this.showModal = true;
    }
  }

  changeWay(event: string): void {
    if(!event) {
      return;
    }
    this.selectedWay = event;
    const legsArray = this.legsFormArray;

    if (event === 'multi') {
      // Multidestino requiere al menos 2 tramos cargados por el usuario
      while (legsArray.length < 2) {
        this.addLeg();
      }
    } else {
      // Ida / Ida y vuelta usan un único tramo cargado; el de regreso
      // (si aplica) se arma automáticamente invirtiendo ese tramo
      while (legsArray.length > 1) {
        this.removeLeg(legsArray.length - 1);
      }
    }
  }

  getStyleBackgroundReturn(): string {

  if(this.selectedWay !== 'way') {
    return 'white';
  } else {
    return '#effef9';
  }

}

noDateDefined(event: any): void {
  const isChecked = event.target.checked;

  this.selectedNoDateDefined = isChecked;

  const legsArray = this.legsFormArray;

  legsArray.controls.forEach(leg => leg.get('date')?.setValue(null));
  this._form.get('returnDate')?.setValue(null);
}

onSubmit(): void {

}

/***********************************************Pasajeros********************************************/

formArray(form: FormGroup, key: string) {
  return (<FormArray>form.get(key)).controls;
}

agesChildsArr(): string[] {
  return Array.from({length: 18}, (_, index) => index.toString());
}

_over() {
  this.modal.emit('false');
}

clickOutside(event: any) {
  this.setPassanger();
}

_confirm() {
  this.isCollapsed = false;
  this.setPassanger();

  setTimeout(() => {
    this.closing = false;
  }, 100);
}

preventModalClose(event: MouseEvent): void {
  event.stopPropagation();
  event.preventDefault();

  const target = event.target as HTMLInputElement;
  target.focus();
}

setPassanger() {
  const adults = this.passengersGroup.get('adults')?.value || 0;
  const childs = this.passengersGroup.get('qtyChilds')?.value || 0;

  this.passengers = `${adults} Adultos - ${childs} Niños`;
}

getPassengerCountAdult(): number {
  return this.passengersGroup.get('adults')?.value || 0;
}

getPassengerCountChildren(): number {
  return this.passengersGroup.get('qtyChilds')?.value || 0;
}

incrementPassengerAdult(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const currentValue = this.passengersGroup.get('adults')?.value || 0;
  if (currentValue >= 10) return;

  this.passengersGroup.patchValue({ adults: currentValue + 1 });
}

decrementPassengerAdult(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const currentValue = this.passengersGroup.get('adults')?.value || 0;
  if (currentValue <= 1) return;

  this.passengersGroup.patchValue({ adults: currentValue - 1 });
}

incrementPassengerChildren(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const currentValue = this.passengersGroup.get('qtyChilds')?.value || 0;
  if (currentValue >= 10) return;

  this.passengersGroup.patchValue({ qtyChilds: currentValue + 1 });

  const ages = this.passengersGroup.get('childsage') as FormArray;
  ages.push(this.formBuilder.group({
    id: [currentValue],
    age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
  }));
}

decrementPassengerChildren(event?: Event) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const currentValue = this.passengersGroup.get('qtyChilds')?.value || 0;
  if (currentValue <= 0) return;

  this.passengersGroup.patchValue({ qtyChilds: currentValue - 1 });

  const ages = this.passengersGroup.get('childsage') as FormArray;
  if (ages.length > 0) {
    ages.removeAt(ages.length - 1);
  }
}

private adjustChildrenAges(newChildCount: number): void {
  const ages = this.passengersGroup.get('childsage') as FormArray;
  const currentCount = ages.length;

  if (newChildCount > currentCount) {
    for (let i = currentCount; i < newChildCount; i++) {
      ages.push(this.formBuilder.group({
        id: [i],
        age: [0, Validators.compose([Validators.required, Validators.min(0), Validators.max(17)])]
      }));
    }
  } else if (newChildCount < currentCount) {
    while (ages.length > newChildCount) {
      ages.removeAt(ages.length - 1);
    }
  }
}

validatePassengerInput(event: any) {
  if (event) {
    event.stopPropagation();
    event.preventDefault();
  }

  const inputValue = parseInt(event.target.value, 10);
  const isAdult = event.target.name === 'adults';

  if (isAdult) {
    const validatedValue = Math.max(1, Math.min(10, isNaN(inputValue) ? 1 : inputValue));
    this.passengersGroup.patchValue({ adults: validatedValue });
  } else {
    const validatedValue = Math.max(0, Math.min(10, isNaN(inputValue) ? 0 : inputValue));
    this.passengersGroup.patchValue({ qtyChilds: validatedValue });
    this.adjustChildrenAges(validatedValue);
  }
}

handleAdultInput(event: any): void {
  if (event.key === '0' && event.target.value === '') {
    event.preventDefault();
    return;
  }

  if (!/^\d$/.test(event.key) &&
      !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    event.preventDefault();
    return;
  }
}

handleAdultBlur(event: any): void {
  const value = event.target.value.trim();

  if (value === '' || value === '0' || isNaN(parseInt(value, 10))) {
    this.passengersGroup.patchValue({ adults: 1 });
    event.target.value = '1';
  } else if (parseInt(value, 10) > 10) {
    this.passengersGroup.patchValue({ adults: 10 });
    event.target.value = '10';
  }
}

handleChildrenInput(event: any): void {
  const currentValue = event.target.value;

  if (event.key === '0' && currentValue === '') {
    event.preventDefault();
    return;
  }

  if (!/^\d$/.test(event.key) &&
      !['Backspace', 'Delete', 'Tab', 'ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
    event.preventDefault();
    return;
  }

  if (/^\d$/.test(event.key) && currentValue.length >= 2) {
    event.preventDefault();
    return;
  }
}

handleChildrenBlur(event: any): void {
  const value = event.target.value.trim();

  if (value === '' || isNaN(parseInt(value, 10))) {
    this.passengersGroup.patchValue({ qtyChilds: 0 });
    event.target.value = '0';
    this.adjustChildrenAges(0);
  } else {
    const numericValue = parseInt(value, 10);
    event.target.value = numericValue.toString();
    this.passengersGroup.patchValue({ qtyChilds: numericValue });
    this.adjustChildrenAges(numericValue);
  }
}

  /**
 * Confirma la acción del modal y lo cierra
 *
 * Este método maneja la acción de confirmación en modales,
 *典型mente ejecutando alguna lógica y luego cerrando el modal.
 *
 * @returns {void}
 *
 * @actions
 * 1. Ejecuta lógica de confirmación (si aplica)
 * 2. Cierra el modal llamando closeModal()
 *
 * @note
 * - Actualmente solo cierra el modal, puede extenderse para más funcionalidad
 */
  confirmAction() {
    this.closeModal();
  }

}
